<template>
  <v-row dense>
    <v-col>
      <ReportHeading
        label="Сервіси до подовження"
        :loading="loading"
        @update-report="updateReport"
      >
        <template v-slot:action>
          <DownloadFile
            :location="
              `reports/services-to-prolongation/rpc/export-to-excel?${filterParams}`
            "
            filename="Сервіси до подовження"
            extension="xlsx"
            tooltip="Завантажити у форматі Excel"
          />
        </template>
        <template v-slot:header-filter>
          <v-col cols="3">
            <DateRangePicker
              :start.sync="dateFrom"
              :end.sync="dateTo"
              :filled="false"
              @change="updateReport"
            />
          </v-col>
        </template>
        <template v-slot:filters>
          <v-row dense>
            <v-col
              md="2"
              sm="12"
            >
              <ManagerSelect
                v-model="manager"
                @input="updateReport"
              />
            </v-col>
            <v-col
              md="3"
              sm="12"
            >
              <ClientSelect
                v-model="client"
                placeholder="Введіть ім'я клієнта"
                @input="updateReport"
              />
            </v-col>
            <v-col
              md="3"
              sm="12"
            >
              <ServiceTypeSelect
                v-model="serviceType"
                @input="updateReport"
              />
            </v-col>
            <v-col
              md="auto"
            >
              <v-switch
                v-model="onlyOverdueService"
                :disabled="loading"
                color="green"
                label="Прострочені"
                dense
                class="mt-1"
                @change="updateReport"
              />
            </v-col>
            <v-col
              md="auto"
            >
              <v-switch
                v-model="stoppedService"
                :disabled="loading"
                color="green"
                label="Зупинені"
                dense
                class="mt-1"
                @change="updateReport"
              />
            </v-col>
          </v-row>
        </template>
      </ReportHeading>

      <v-row dense>
        <v-col
          cols="12"
          sm="4"
          class="py-2"
        >
          <v-card class="mr-1 pa-1 d-flex align-center">
            <span class="subtitle-1">Клієнт/Сервісів:</span>
            <v-spacer /><span
              class="title"
            >{{ clientsCount }}/{{ servicesCount }}</span>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          class="py-2"
        >
          <v-card class="mx-1 pa-1 d-flex align-center">
            <span class="subtitle-1">Прострочені:</span>
            <v-spacer /><span
              class="title"
            >{{ servicesStopped
            }}<small>({{ servicesStoppedPercent.toFixed(0) }}%)</small></span>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          class="py-2"
        >
          <v-card class="ml-1 pa-1 d-flex align-center">
            <span class="subtitle-1">Скоро закінчуються:</span>
            <v-spacer /><span
              class="title"
            >{{ servicesStoppedSoon
            }}<small>({{ servicesStoppedSoonPercent.toFixed(0) }}%)</small></span>
          </v-card>
        </v-col>
      </v-row>

      <v-card>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="items"
          hide-default-footer
          flat
          :items-per-page="items.length"
          height="63vh"
        >
          <template v-slot:item="{ item }">
            <tr
              :class="{
                'red--text': item.remainingDays <= 1,
                'green--text': item.remainingDays > 14,
                'amber--text':
                  item.remainingDays <= 14 && item.remainingDays > 1,
              }"
            >
              <td>
                <ReferenceTitle
                  :id="item.client.id"
                  component-name="Client"
                  :title="item.client.title"
                />
              </td>
              <td>
                <ReferenceTitle
                  :id="item.manager ? item.manager.id : null"
                  component-name="Manager"
                  :title="item.manager ? item.manager.title : ''"
                />
              </td>
              <td>
                <ReferenceTitle
                  :id="item.service.id"
                  component-name="Service"
                  :title="item.service.shortTitle"
                >
                  <template v-slot:quantity>
                    <span>({{ item.quantity }} шт)</span>
                  </template>
                </ReferenceTitle>
              </td>
              <td>
                {{ item.payedTo | date }}
              </td>
              <td>{{ item.remainingDays }}</td>
              <td>
                <v-chip
                  label
                  small
                  :color="item.stoppedService ? 'red' : 'green'"
                >
                  {{ item.stoppedService ? "Так" : "Ні" }}
                </v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import ManagerSelect from "../../catalogs/managers/ManagerSelect.vue";
import DownloadFile from "../../../components/DowloadFile.vue";
import DateRangePicker from "@/components/story/DateRangePicker.vue";
import ReferenceTitle from "../../../components/ReferenceTitle.vue";
import * as reportsApi from "../../../backend/reportsApi.js";
import ReportHeading from "../../../components/ReportHeading.vue";
import ClientSelect from "../../../components/selects/ClientSelect.vue";
import ServiceTypeSelect from "../../catalogs/service-types/ServiceTypeSelect.vue";

export default {
  components: {
    ManagerSelect,
    DownloadFile,
    DateRangePicker,
    ReferenceTitle,
    ReportHeading,
    ClientSelect,
    ServiceTypeSelect,
  },
  data: () => ({
    dateFrom: "",
    dateTo: "",
    onlyOverdueService: false,
    stoppedService: false,
    loading: false,
    items: [],
    headers: [
      { text: "Клієнт", align: "left", sortable: false },
      { text: "Менеджер", align: "left", sortable: false },
      { text: "Сервіс", align: "left", sortable: false },
      { text: "Сплачено до", align: "left", sortable: false },
      { text: "Залишилося днів", align: "left", sortable: false },
      { text: "Сервіс зупинено", align: "left", sortable: false },
    ],
    manager: null,
    client: null,
    serviceType: null,
  }),
  computed: {
    clientsCount() {
      const uniqClients = [];
      this.items.forEach((i) => {
        if (uniqClients.indexOf(i.client.id) === -1) {
          uniqClients.push(i.client.id);
        }
      });
      return uniqClients.length;
    },
    servicesCount() {
      return this.items.length;
    },
    servicesStopped() {
      const stopped = this.items.filter((i) => i.remainingDays <= 1);
      return stopped ? stopped.length : 0;
    },
    servicesStoppedSoon() {
      const stoppedSoon = this.items.filter(
        (i) => i.remainingDays <= 14 && i.remainingDays > 1
      );
      return stoppedSoon ? stoppedSoon.length : 0;
    },
    servicesStoppedPercent() {
      return this.servicesCount !== 0
        ? (this.servicesStopped / this.servicesCount) * 100
        : 0;
    },
    servicesStoppedSoonPercent() {
      return this.servicesCount !== 0
        ? (this.servicesStoppedSoon / this.servicesCount) * 100
        : 0;
    },
    filterParams() {
      return `managerId=${this.manager?.id ?? ""}
              &clientId=${this.client?.id ?? ""}
              &onlyStopped=${this.stoppedService}
              &serviceTypeId=${this.serviceType?.id ?? ""}
              &onlyOverdueService=${this.onlyOverdueService}
              &dateFrom=${this.dateFrom}
              &dateTo=${this.dateTo}`;
    },
  },
  created() {
    this.updateReport();
  },
  methods: {
    async updateReport() {
      this.loading = true;

      const filter = {
        managerId: this.manager ? this.manager.id : "",
        clientId: this.client ? this.client.id : "",
        onlyStopped: this.stoppedService,
        serviceType: this.serviceType ? this.serviceType.id : "",
        onlyOverdueService: this.onlyOverdueService,
        dateFrom: this.dateFrom || "",
        dateTo: this.dateTo || "",
      };
      try {
        this.items = await reportsApi.getServicesToProlongation(
          filter.managerId,
          filter.clientId,
          filter.onlyStopped,
          filter.serviceType,
          filter.onlyOverdueService,
          filter.dateFrom,
          filter.dateTo
        );
      } catch {
        this.$notifyWarning(
          "В даних звіту помилки. Подивіться в Система/Стан БД"
        );
      }

      this.loading = false;
    },
  },
};
</script>
